var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('RecycleScroller',{attrs:{"items":_vm.data,"item-size":40,"key-field":"userId"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('check-cell',{attrs:{"item":item,"label":item[_vm.config.value],"disabled":_vm.disabled,"props":_vm.config},on:{"change":function($event){return _vm.userCheck(item, _vm.index)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }